export const SKILLS = [
    {
        title: "Web Dev",
        icon: 'Icons/front end.png',
        skills: [
            {skill: "HTML5", percentage: "80%"},
            {skill: "CSS3", percentage: "75%"},
            {skill: "JavaScript", percentage: "70%"},
            {skill: "ReactJS", percentage: "70%"},
        ],
    },

    {
        title: "Data Analytics",
        icon: 'Icons/data analytics.png',
        skills: [
            {skill: "Python", percentage: "85%"},
            {skill: "Scripting", percentage: "80%"},
            {skill: "Data Visualization", percentage: "75%"},
            {skill: "Data Manipulation", percentage: "80%"}
        ],
    },

    {
        title: "Tools",
        icon: 'Icons/Tools.png',
        skills: [
            {skill: "GitHub", percentage: "70%"},
            {skill: "VS Code", percentage: "75%"},
            {skill: "AWS", percentage: "50%"},
            {skill: "Jupyter", percentage: "85%"},
        ],
    },

    {
        title: "Soft Skills",
        icon: 'Icons/soft-skills.png',
        skills: [
            {skill: "Problem Solving", percentage: "85%"},
            {skill: "Collaboration", percentage: "90%"},
            {skill: "Communication", percentage: "85%"},
            {skill: "Adaptability", percentage: "85%"},
        ],
    }
];

export const WORK_EXPERIENCE = [

    {
        title: "Consultant(Volunteer), CSDH, Vancouver, Canada",
        date: "Jan 2024 - Mar 2024",
        responsibilities: [
            "Performed primary research by conducting 1:1 interviews to gain member's perceptions about the organization",
            "Performed comprehensive secondary research, analyzing industry trends, offerings, and competitor strategies ",
            "Conducted SWOT analysis for CSDH to highlight opportunities and build recommendations",
            "Scheduled regular meetings with the client and presented our case to stakeholders",
            "Recommended short term and long-term strategies aimed at increasing member count and brand awareness by 50%",
        ],
    },

    {
        title: "Software Developer, Wipro, India",
        date: "December 2020 - February 2022",
        responsibilities: [
            "Collaborated as a developer for Apple's Performance team; monitoring Apple Online Store and data centres.",
            "Developed allocation web tool using HTML, CSS, JS, SQL, and JAVA; reduced host allocation time by more than 50%.",
            "Led migration of internall web application to AWS, utilising EC2 and ECS to host services.",
            "Automated daily Scripter analysis tool, resulting in 100% reduction in daily manual labor for this task.",
            "Improved the Report tool and Warm up tool by adding new features and resolving bugs, ensuring high quality output."
        ],
    },
];

export const PROJECTS = [

    {
        title: "Deloitte Australia, Tech Consulting job simulation",
        date: "Jul 2024",
        responsibilities: [
            "Completed a job simulation involving data analysis for Deloitte’s Technology team",
            "Created a data dashboard using Tableau extracting data insights from 4 client sites",
            "Wrote a proposal for a client project outlining scope and estimated timeline to create a functioning dashboard",
            "Used Excel to classify data and draw business conclusions to support the client in a cybersecurity breach",
        ],
    },


    {
        title: "Doodle, AI Chatbot",
        date: "Jun 2024 - Jul 2024",
        responsibilities: [
            "Leveraged llama3, a large language model, to enhance conversational depth and accuracy.",
            "Enhanced performance and speed, delivering real-time interactions with minimal latency. (10x faster than Gemini, 18x faster than OpenAI/ChatGPT)",
            "Designed a modern and user-friendly interface using ReactJS, ensuring a responsive and visually appealing platform.",
            "Implemented a robust backend powered by Flask and REST API, enabling scalability and reliability.",
        ],
    },


    {
        title: "Sentiment Analysis, UBC Sauder, Canada",
        date: "September 2023 - October 2023",
        responsibilities: [
            "Analyzed a dataset of 5000 tweets containing the keyword 'Messi' with a 3-member team using Python.",
            "Contributed to the extraction of insights that informed decision-making processes.",
            "Employed Pandas for efficient data manipulation and Matplotlib for insightful visualization of diverse tweet sentiments.",
            "Utilized Text Blob to compute polarity and subjectivity scores, extracting valuable insights from the tweets.",
        ],
    },

    {
        title: "Stock Market Analysis, India",
        date: "October 2021 - November 2021",
        responsibilities: [
            "Utilized Pandas in Python to develop a robust script for the efficient manipulation and precise filtering of stock market data.",
            "Implemented data analysis techniques, focusing on parameters like Open Interest and Volume.",
            "Achieved a significant 100% reduction in manual labor through process automation, optimizing efficiency.",
            "Saved up valuable time for strategic analysis and accurate decision-making by streamlining the routine tasks.",
        ],
    }
];